import React from "react";
import { Link } from "react-router-dom";

import { useGlobalContext } from "../../context/context";

import "./navbar.css";

const Navbar = () => {
  const {
    toggleSubmenu,
    openSidebar,
    isSidebar,
    closeSidebar,
    isSubmenu,
  } = useGlobalContext();

  return (
    <header className="header py-2">
      <div
        className={`header-backdrop ${isSidebar ? "active" : null}`}
        onClick={closeSidebar}
      ></div>
      <nav className="navbar p-0">
        <div className="container d-flex justify-content-between ">
          <div className="navbar-brand">
            <i><Link to="/" className=" text-uppercase fs-3 fw-bold">
              <span>Smart</span>Basic
            </Link></i>
          </div>
          <button
            onClick={openSidebar}
            type="button"
            className="navbar-togglre d-lg-none fs-1"
          >
            <i className="fa fa-bars"></i>
          </button>
          <div
            className={`navbar-nav-container py-3 py-lg-0 ${
              isSidebar ? "active" : null
            } `}
          >
            <button
              className="header-close-btn d-lg-none theme-bg fs-3 rounded-1 mx-3 mx-lg-0 mb-3 mb-lg-0 "
              onClick={closeSidebar}
              type="button"
            >
              <i className="fa fa-times"></i>
            </button>
            <ul className="navbar-nav d-flex flex-lg-row flex-column align-lg-items-center fs-5">
              <li className="nav-item me-5 ">
                <Link
                  onClick={closeSidebar}
                  className="nav-link  px-3 px-lg-0"
                  to="/"
                >
                  Početna
                </Link>
              </li>
              
              <li className="nav-item me-5 ">
                <div onClick={toggleSubmenu} className="px-3 px-lg-0 d-flex align-items-center justify-content-between">
  <Link
    to="/courses"
    onClick={closeSidebar} // optional: if you want sidebar to close
    className="text-decoration-none text-dark"
  >
    Kursevi
  </Link>
  <i
    className={`fas fa-chevron-down fs-6 ms-2 ms-lg-1 ${isSubmenu ? "rotate" : ""}`}
  ></i>
</div>

                <ul
                  className={`sub-menu rounded-2 px-lg-2 ${
                    isSubmenu ? "active" : ""
                  } `}
                >
                  <li className="nav-item">
  <Link
    onClick={closeSidebar}
    to="/singlecourse/matematika-ekonomski"  // dynamic part
    className="nav-link px-5 px-lg-0"
  >
    Matematika-Ekonomski
  </Link>
  
</li>
<li className="nav-item">
  <Link
    onClick={closeSidebar}
    to="/singlecourse/matematika-1-fon"      // another course
    className="nav-link px-5 px-lg-0"
  >
    Matematika 1 - FON
  </Link>
</li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/matematika-2-fon"
                      className="nav-link px-5 px-lg-0"
                    >
                      Matematika 2 - FON
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/matematika-3-fon"
                      className="nav-link px-5 px-lg-0"
                    >
                      Matematika 3 - FON
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/matematika-1-saobracajni"
                      className="nav-link px-5 px-lg-0"
                    >
                      Matematika 1 - Saobraćajni
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/diskretna-matematika-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Diskretna Matematika - Ekonomski 
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/osnovi-ekonomije-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Osnovi Ekonomije - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/statistika-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Statistika - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/mikroekonomija-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Mikroekonomija - Ekonomski 
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/osnovi-operacionih-istraživanja-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                     Osnovi operacionih istraživanja - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/upravljačko-računovodstvo-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Upravljačko računovodstvo - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/linearna-algebra-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Linearna algebra - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/teorija-verovatnoća-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Teorija verovatnoća - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/finansijska-aktuarska-matematika-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Finansijska i aktuarska matematika - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/teorija-odlučivanja-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Teorija odlučivanja - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/teorijska-statistika-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Teorijska statistika - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/ekonomska-statistika-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Ekonomska statistika - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/racunovodstvo-troskova-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Računovodstvo troškova - Ekonomski
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/verovatnoća-fon"
                      className="nav-link px-5 px-lg-0"
                    >
                      Verovatnoća - FON
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/statistika-fon"
                      className="nav-link px-5 px-lg-0"
                    >
                      Statistika - FON
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/ekonomski-prijemni"
                      className="nav-link px-5 px-lg-0"
                    >
                      Ekonomski prijemni
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/fon-prijemni"
                      className="nav-link px-5 px-lg-0"
                    >
                      FON prijemni
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={closeSidebar}
                      to="singlecourse/finansijska-matematika-za-master-ekonomski"
                      className="nav-link px-5 px-lg-0"
                    >
                      Finansijska matematika za master - Ekonomski
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item ">
                <Link
                  onClick={closeSidebar}
                  className="nav-link px-3 px-lg-0"
                  to="/contact"
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
